jQuery(document).ready(function($) {

	$('.off-canvas__close').on('click', function(event) {
		event.preventDefault();

		$('.js-off-canvas-overlay').trigger('click');
	});

	$('.menu-item.active:not(.menu-item-has-children)').on('click', function(event) {
		event.preventDefault();

		$('.js-off-canvas-overlay').trigger('click');
	});
});
